import React from "react";
import PropTypes from "prop-types";

import { Card, ReduxControls } from "rhombus-react";
import { Field, FormSection } from "redux-form";

import { CAROUSEL_AD_TYPES } from "utils/constants";
import { MAX_CAROUSEL_CARDS_BY_ADTYPE } from "social/constants";

import CardHeader from "./CardHeader";
import CardSelector from "./CardSelector";

import "./GoogleDemandGenCardContent.css";

function googleThumbnailNameSelector(card){
	return card?.images?.square?.name || card?.images?.horizontal?.name;
}

export default function GoogleDemandGenCardContent(props){
	const {
		libraryId,
		adType,
		isViewOnly,
		showPristineErrors,
		navigationActions,
		CardForm,
	} = props;

	const maxCards = MAX_CAROUSEL_CARDS_BY_ADTYPE[adType];

	return (
		<Card
			className="carousel-card-content"
			header = {(
				<span className="c-heading-descriptive">
					{`Card Content - Carousel must contain between 2-${maxCards} cards`}
				</span>
			)}
			isCollapsable
			isVisible
		>
			<FormSection
				name="requiredAspectRatios"
				className="aspect-ratios e-form__control-wrapper required"
			>
				<label className="e-form__control-label">
					Select Aspect Ratios:
				</label>
				<Field
					name="square"
					label="Square"
					className="aspect-ratio-option inverted-check"
					component={ReduxControls.Checkbox}
					useValue
				/>
				<Field
					name="horizontal"
					label="Horizontal"
					className="aspect-ratio-option inverted-check"
					component={ReduxControls.Checkbox}
					useValue
				/>
				<Field
					name="vertical"
					label="Vertical"
					className="aspect-ratio-option inverted-check"
					component={ReduxControls.Checkbox}
					useValue
				/>
			</FormSection>
			<CardSelector
				adType={adType}
				libraryId={libraryId}
				isViewOnly={isViewOnly}
				showPristineErrors={showPristineErrors}
				thumbnailNameSelector={googleThumbnailNameSelector}
			/>
			<div className="form-container">
				<CardHeader adType={adType} isViewOnly={isViewOnly} />
				<CardForm
					libraryId = {libraryId}
					isViewOnly = {isViewOnly}
					showPristineErrors = {showPristineErrors}
					navigationActions = {navigationActions}
					adType = {adType}
				/>
			</div>
		</Card>
	);
}

GoogleDemandGenCardContent.displayName = "GoogleDemandGenCardContent";
GoogleDemandGenCardContent.propTypes = {
	libraryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	adType: PropTypes.oneOf(CAROUSEL_AD_TYPES),
	showPristineErrors: PropTypes.bool,
	navigationActions: PropTypes.object,
};
